import { useTranslation } from 'next-i18next';
import { logger } from '@zep/core-logger';
import { Button, Stack } from '@zep/ui';
import { cn } from '@zep/utils';
import { fDateByCountryCode } from '../../../../utils';
import { useGoSubscriptionPayment } from '../hooks';
import { usePlanSpaceDetailContext } from '../plan';
import { PlanSpaceGroup } from '../space/organisms';
import S from './AppliedPlan.module.scss';
import { PlanTypeLabel } from './PlanTypeLabel';
const FREE_MAX_CCU = 10;
export const CurrentPlanExpired = () => {
  const {
    t
  } = useTranslation(['subscription']);
  const move = useGoSubscriptionPayment();
  const {
    spacePlan,
    space
  } = usePlanSpaceDetailContext();
  const handleClickUpgrade = () => {
    if (spacePlan == null) return;
    move({
      spaceHashId: spacePlan.spaceHashId
    });
    logger.track('home_subscription_plan_upgrade', {
      place: 'details'
    });
  };
  return <PlanSpaceGroup title={t('subscription:SpaceDetail.menuManage.currentPlan')} data-sentry-element="PlanSpaceGroup" data-sentry-component="CurrentPlanExpired" data-sentry-source-file="CurrentPlanExpired.tsx">
      <Stack gap={8} style={{
      justifyContent: 'center',
      alignItems: 'flex-start'
    }} data-sentry-element="Stack" data-sentry-source-file="CurrentPlanExpired.tsx">
        <PlanTypeLabel planType={'FREE'} maxCcu={FREE_MAX_CCU} data-sentry-element="PlanTypeLabel" data-sentry-source-file="CurrentPlanExpired.tsx" />
        <Stack gap={8} style={{
        alignItems: 'flex-start'
      }} data-sentry-element="Stack" data-sentry-source-file="CurrentPlanExpired.tsx">
          <label className={cn(S.label, 'text-[#27262ea3]')}>
            {t('subscription:SpaceDetail.menuManage.currentPlanExpiredMessage', {
            expiredDate: fDateByCountryCode(spacePlan?.endDate ?? Date.now(), space.countryCode),
            expiredPlan: spacePlan?.planType
          })}
          </label>
          <Button size={'xs'} onClick={handleClickUpgrade} data-sentry-element="Button" data-sentry-source-file="CurrentPlanExpired.tsx">
            {t('subscription:SpaceDetail.menuManage.upgradePlan')}
          </Button>
        </Stack>
      </Stack>
    </PlanSpaceGroup>;
};